module.exports = __webpack_public_path__ + "static/media/logo-truemoney_3.3d40672d.png";